import { Grid } from '@mui/material';
import { HexColor } from '@nx-smartmonkey/shared/domain';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import { getRouteStatusColor } from '../../../constants/Colors';
import { RouteStatus } from '../../../domain/route/RouteStatus';

type RouteStatusBarTypes = {
  status: RouteStatus;
};

export const RouteStatusBar = ({ status }: RouteStatusBarTypes) => {
  return (
    <div
      style={{
        minWidth: `4px`,
        height: `100%`,
        backgroundColor: getRouteStatusColor(status),
        borderRadius: `4px`,
      }}
    />
  );
};

type RouteColorBarTypes = {
  color?: HexColor;
  style?: React.CSSProperties;
};

export const RouteColorBar = ({ color, style }: RouteColorBarTypes) => {
  return (
    <Grid
      item
      style={{
        ...style,
        minWidth: `4px`,
        height: `100%`,
        backgroundColor: color ? color.value : RoutalPalette.routeStatusColors.pending.medium,
        borderRadius: `4px`,
      }}
    />
  );
};
